import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-tpl-variable',
  template: `
    <nz-form-item *ngIf="variableBinds && variableBinds.length > 0">
      <nz-form-label [nzSpan]="3">业务变量</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <icc-tags [theme]="v.isRequired ? 'cyan' : 'gray'" *ngFor="let v of variableBinds" (click)="insertHandle(v)" [notDelete]="true" style="cursor: pointer;">
          <span nzTooltipTitle="点击变量添加到模板内容中" nzTooltipPlacement="top" nz-tooltip>{{ v.name }}</span>
        </icc-tags>
      </nz-form-control>
    </nz-form-item>
  `,
  styles: [],
})
export class IccTplVariableComponent implements OnInit {
  /** 业务变量数组 */
  @Input() variableBinds: any[] = [];
  /** 点击事件的回调 */
  @Output() insert = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  insertHandle(value) {
    this.insert.next(value);
  }
}
